import type { UseQueryOptions } from '@tanstack/react-query';
import type { UserProfile } from '../types';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { PROFILE_API_ROOT } from '../constants';

export function getUserProfile(userId: number): Promise<UserProfile> {
  return FetchPromise.get(`${PROFILE_API_ROOT}/${userId}`);
}

export function useUserProfileQuery(userId: number, queryOptions: UseQueryOptions<UserProfile, JQuery.jqXHR> = {}) {
  return useQuery<UserProfile, JQuery.jqXHR>(
    ['profile', `profile/${userId}`],
    () => getUserProfile(userId),
    queryOptions,
  );
}
